import { render, staticRenderFns } from "./GoodsPlay.vue?vue&type=template&id=5a1962fc&scoped=true"
import script from "./GoodsPlay.vue?vue&type=script&lang=js"
export * from "./GoodsPlay.vue?vue&type=script&lang=js"
import style0 from "./GoodsPlay.vue?vue&type=style&index=0&id=5a1962fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1962fc",
  null
  
)

export default component.exports